import {PageLayout} from '@primer/react'

import styles from './ThreePanesLayout.module.css'

export type PaneWithAriaLabel = {
  element: React.ReactElement
  ariaLabel: string
}

export type ThreePanesLayoutProps = {
  leftPane?: PaneWithAriaLabel
  middlePane?: React.ReactElement
  contentAs?: React.ElementType
  rightPane?: PaneWithAriaLabel
  rightPanePadding?: boolean
  rightPaneAs?: React.ElementType
  resizeable?: boolean
  leftPaneWidth?: 'small' | 'medium' | 'large'
}

export function ThreePanesLayout({
  leftPane,
  middlePane,
  contentAs,
  rightPane,
  rightPanePadding = true,
  rightPaneAs,
  resizeable = true,
  leftPaneWidth = 'large',
}: ThreePanesLayoutProps) {
  return (
    <PageLayout containerWidth="full" columnGap="none" className={styles.ThreePanesLayout}>
      {leftPane && (
        <PageLayout.Pane
          width={leftPaneWidth}
          position="start"
          divider="line"
          padding="condensed"
          resizable={resizeable}
          widthStorageKey="hyperlist.pane-sidewidth"
          aria-label={leftPane.ariaLabel}
          className={styles.ThreePanesLayoutLeftPane}
        >
          {leftPane.element}
        </PageLayout.Pane>
      )}
      <PageLayout.Content as={contentAs}>
        {rightPane ? (
          <PageLayout containerWidth="full" columnGap="none" className={styles.ThreePanesLayoutNested}>
            {middlePane && (
              <PageLayout.Pane
                width="large"
                divider="line"
                resizable={resizeable}
                widthStorageKey="hyperlist.pane-details-width"
                padding="condensed"
                position="start"
                aria-label={rightPane.ariaLabel}
                className={styles.ThreePanesLayoutMiddlePane}
              >
                {middlePane}
              </PageLayout.Pane>
            )}
            {rightPane && (
              <PageLayout.Content as={rightPaneAs} padding={rightPanePadding ? 'normal' : 'none'}>
                {rightPane.element}
              </PageLayout.Content>
            )}
          </PageLayout>
        ) : middlePane ? (
          <div className={styles.ThreePanesLayoutMiddleOnlyPane}>{middlePane}</div>
        ) : null}
      </PageLayout.Content>
    </PageLayout>
  )
}
